module.exports = new __parcel__URL__("julekalender_header_mobil.f68ea17f.png").toString();